import './OpinionForm.scss';
import ContactForm from '../../../common/scripts/ContactForm.js';
class OpinionForm {
    constructor( node ) {
        this.node = node;
        this.obj = new ContactForm();
    }
    init() {
        let t = this;
        let formData = new FormData();
        let formDataFields = {};
        let fields = t.node.querySelectorAll('.OpinionForm__content [data-field]');
        let submitBtn = t.node.querySelector('.OpinionForm__content .content__footer .footer__submit');

        t.node.addEventListener('submit', ( event ) => {
            event.preventDefault();

            if( submitBtn.hasAttribute('disabled') ) {
                return;
            }
            submitBtn.setAttribute('disabled', 1);
            t.callback({ remove: 1 });

            fields.forEach( ( node, index ) => {
                t.obj.checkField( node );
            });

            if( t.node.querySelectorAll('.OpinionForm__content [aria-invalid]').length > 0 ) {
                t.callback({
                    message : t.node.getAttribute('data-empty')
                });
                submitBtn.removeAttribute('disabled');
                return;
            }

            formData = new FormData();
            formData.append( 'action', 'submit_opinion_form' );
            formData.append( 'ip_address', t.node.querySelector('input[name="ip_address"]').value );
            formDataFields = [];
            fields.forEach( ( field, index ) => {
                formDataFields.push( t.obj.getData( field ) );
            });
            formData.append( 'fields', JSON.stringify(formDataFields) );

            grecaptcha.ready( async () => {
                formData.append( 'nonce', await grecaptcha.execute('6LelfvIpAAAAAMJMrmLdDaji2_bq-XZpFdToqz70', {action: 'submit_opinion_form'} ) );

                fetch( window.location.origin +'/wp-admin/admin-ajax.php', {
                    method: 'POST',
                    body : formData
                })
                .then( ( response ) => {
                    return response.json();
                })
                .then( ( json ) => {
                    submitBtn.removeAttribute('disabled');
                    console.log( json );

                    if( json && json.status && json.status == 'success' ) {

                        t.thanksView( true );
                        fields.forEach( ( row, index ) => {
                            t.obj.resetField( row );
                        });

                    } else {
                        t.callback({
                            message : t.node.getAttribute('data-error')
                        });
                    }
                })
                .catch( ( message ) => {
                    console.error( message );
                    t.callback({
                        message : t.node.getAttribute('data-error')
                    });
                });

            });

        });

        t.node.querySelector('.OpinionForm__wrapper .content__button').addEventListener('click', () => {
            t.thanksView( false );
        });

    }
    callback( args = {} ) { 
        let t = this;
        // display only on error
        if( !args.position ) { args.position = 'beforebegin' };
        if( !args.element ) { args.element = t.node.querySelector('.OpinionForm__content .content__footer') };

        if( args.remove ) {
            t.node.querySelectorAll('.OpinionForm__callback').forEach( ( content, index ) => {
                content.remove();
            });
        }
        if( args.message && args.element ) {
            args.element.insertAdjacentHTML( args.position, '<div class="OpinionForm__callback"><span class="callback__label">'+t.node.getAttribute('data-error-label')+'</span><span class="callback__text">'+args.message+'</span></div>' );
        }

    }
    thanksView( display = true /* true - display / false - hide */ ) {
        let t = this;
        if( display ) {
            t.node.style.height = t.node.querySelector('.OpinionForm__content').offsetHeight + 'px';
            t.node.classList.add('sended');
            t.node.style.height = t.node.querySelector('.OpinionForm__wrapper').offsetHeight + 'px';
            setTimeout(() => {
                t.node.style.height = 'auto';
            }, 200 );
        } else {
            t.node.style.height = t.node.querySelector('.OpinionForm__wrapper').offsetHeight + 'px';
            t.node.classList.remove('sended');
            t.node.style.height = t.node.querySelector('.OpinionForm__content').offsetHeight + 'px';
            setTimeout(() => {
                t.node.style.height = 'auto';
            }, 200 );
        }
    }
}
JSModules['OpinionForm'] = OpinionForm;
export default OpinionForm;